module.exports = __webpack_public_path__ + "static/media/cross.04343631.svg";